import { asInstanceOf, MutableObservableOption, StringMapping, Terminator, ValueMapping } from "@opendaw/lib-std";
import { MIDIOutputBox, MIDIOutputParameterBox } from "@opendaw/studio-boxes";
import { Devices } from "../../DeviceAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
import { TrackType } from "../../timeline/TrackType";
export class MIDIOutputDeviceBoxAdapter {
    #terminator = new Terminator();
    type = "instrument";
    accepts = "midi";
    #context;
    #box;
    #midiDevice;
    #parametric;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#midiDevice = new MutableObservableOption();
        this.#parametric = this.#terminator.own(new ParameterAdapterSet(this.#context));
        this.#terminator.ownAll(box.parameters.pointerHub.catchupAndSubscribe({
            onAdded: (({ box }) => this.#parametric
                .createParameter(asInstanceOf(box, MIDIOutputParameterBox).value, ValueMapping.unipolar(), StringMapping.percent({ fractionDigits: 1 }), "", 0.0)),
            onRemoved: (({ box }) => this.#parametric
                .removeParameter(asInstanceOf(box, MIDIOutputParameterBox).value.address))
        }), this.#box.device.catchupAndSubscribe(({ targetVertex }) => targetVertex.match({
            none: () => this.#midiDevice.clear(),
            some: ({ box }) => this.#midiDevice.wrap(asInstanceOf(box, MIDIOutputBox))
        })));
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get labelField() { return this.#box.label; }
    get iconField() { return this.#box.icon; }
    get defaultTrackType() { return TrackType.Notes; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get acceptsMidiEvents() { return true; }
    get parameters() { return this.#parametric; }
    get midiDevice() { return this.#midiDevice; }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { this.#terminator.terminate(); }
}
